import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";

const CommonDatePicker = ({
  values,
  setValues,
  errors,
  setErrors,
  label,
  name,
  dateFormat,
  showTimeInput,
  hasInfoIcon,
  tooltipText,
  type,
  not_required,
  minDate,
  maxDate,
  dropdownMode,
  isDisabled,
  showTimeSelect,
  timeIntervals,
  filterTime,
  showMonthDropdown,
  showYearDropdown,
  isChanged,
  setIsChanged,
}) => {
  const { t } = useTranslation("common");
  const today = new Date();

  return (
    <div>
      <label className={`create_from_label ${!not_required && "required"}`}>
        {label}
        {hasInfoIcon && (
          <div className="create_from_label_info_icon tooltip">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
            <span className="tooltiptext">{tooltipText}</span>
          </div>
        )}
      </label>
      <DatePicker
        placeholderText={`${t("common.Select")} ${label}`}
        wrapperClassName="date-picker_container create_from_input_content"
        className={`date-picker_input create_from_input ${
          isDisabled === true && "visitor_disabled_input"
        }`}
        selected={values[name]}
        onChange={(date) => {
          // console.log("date==>", date);
          // console.log("date", new Date());
          setValues({ ...values, [name]: date });
          setErrors({ ...errors, [name]: "" });
          if (isChanged && isChanged === "0") {
            setIsChanged("1");
          }
        }}
        minDate={
          minDate
            ? minDate
            : type !== "issue" &&
              type !== "announcement_date" &&
              type !== "ann_start_date" &&
              today
        }
        dateFormat={dateFormat ? dateFormat : "dd/MM/yyyy"}
        showTimeInput={showTimeInput}
        maxDate={maxDate}
        showTimeSelect={showTimeSelect}
        timeIntervals={timeIntervals}
        filterTime={filterTime}
        dropdownMode={dropdownMode}
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        disabled={isDisabled}
      />
      {errors[name] && <span className="err_text">{errors[name]}</span>}
    </div>
  );
};

export default CommonDatePicker;
